import { render } from "./SquadPlayers.vue?vue&type=template&id=216c7b7e"
import script from "./SquadPlayers.vue?vue&type=script&lang=js"
export * from "./SquadPlayers.vue?vue&type=script&lang=js"

import "./SquadPlayers.vue?vue&type=style&index=0&id=216c7b7e&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__